import * as Sentry from "@sentry/react";
import { propagationContextFromHeaders } from "@sentry/core";
import getSentryConfig from "./sentryConfig";
import patchFetchForSentryTrace from "./sentryTraceFetch";

function debugLog(...msgArr) {
  if (window.LOCAL_DEV) {
	console.debug(...msgArr);
  }
}

const isProd = window.ENVIRONMENT == "production";
const validRelease = /^[\d\.]+$/.test(window.SITE_SENTRY_RELEASE || "");

if (window.SENTRY_DSN && (!isProd || validRelease)) {
  const config = getSentryConfig(Sentry)
  if (!Sentry.getClient()) {
	Sentry.init(config);
	Sentry.getCurrentScope().setPropagationContext(
	  propagationContextFromHeaders(window.SENTRY_TRACE, window.SENTRY_BAGAGGE)
	);
	patchFetchForSentryTrace(Sentry);
	console.log('[Sentry] initialized from @sentry/react SDK, client:', Sentry.getClient()?.getOptions()?.dsn);
	debugLog("Initialized Sentry with", config, Sentry);
  } else {
	console.log('[Sentry] @sentry/react SDK already initialized, skipping');
  }
} else if (!window.LOCAL_DEV) {
  console.warn("Sentry error logging disabled");
}
export { Sentry };
